import { ChecklistCategoryInterface } from '../interfaces/checklistCategory';
import { Checklist } from "./checklist";
import { ChecklistSubCategory } from "./checklistSubCategory";

export class ChecklistCategory implements ChecklistCategoryInterface {
    id_checklist_category?: number;
    fk_id_checklist?: number;
    checklist_subcategories: Array<ChecklistSubCategory>;
    checklist: Checklist
    name: string;
    code: string;
    description: string;
    index: number;

    constructor() {
        this.fk_id_checklist = 0;
        this.checklist = new Checklist();
        this.checklist_subcategories = [];
        this.name = '';
        this.code = '';
        this.description = '';
        this.index = 0;
    }
}